import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FinfraDashboardContainerComponent} from './finfra-dashboard-container.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {ThrottleClickModule, TranslateModule} from '@atumverse/core-decorators';
import {MatDividerModule} from '@angular/material/divider';
import {
  FinfraTransactionSearchByModule,
  FinfraTransactionFooterModule,
  FinfraStartTransactionModule,
  FinfraSearchButtonDashboardWidgetModule,
  FinfraTransactionListModule,
  FinfraAgeingChartWidgetModule,
  FinfraFunctionCountChartModule,
  FinfraFilterWidgetModule
} from '@atumverse/app-core-widgets';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
//import {FinfraAgeingChartWidgetModule} from '../finfra-dashboard-items/finfra-ageing-chart/finfra-ageing-chart.module';
//import { FinfraFunctionCountChartModule } from '../finfra-dashboard-items/finfra-function-count-chart/finfra-function-count-chart.module';
//import { FinfraFilterWidgetModule } from '../finfra-dashboard-items/finfra-filter/finfra-filter.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,

        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatCardModule,
        MatExpansionModule,
        MatDividerModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatChipsModule,
        MatSidenavModule,
        MatDialogModule,
        MatRadioModule,
        MatCheckboxModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,

        TranslateModule,
        FinfraTransactionSearchByModule,
        FinfraTransactionFooterModule,
        FinfraStartTransactionModule,
        FinfraSearchButtonDashboardWidgetModule,
        FinfraTransactionListModule,
        FinfraAgeingChartWidgetModule,
        FinfraFunctionCountChartModule,
        FinfraFilterWidgetModule,
        ThrottleClickModule,


    ],
  declarations: [FinfraDashboardContainerComponent],
  exports: [FinfraDashboardContainerComponent]
})
export class FinfraDashboardContainerModule {
}
